import styled from "styled-components";
import { useContext } from "react";
import Context from "../../../Context.js";
import BrandContainer from "../../brand/BrandContainer.js";
import MembershipMiniInfo from "./MembershipMiniInfo.js";
import NavBar from "./NavBar.js";
import NavBarWithInvertedCurve from "./NavBarWithInvertedCurve.js";
import PwaInstallButton from "../../pwa/PwaInstallButton.js";

const TopPart = styled.div`
  display: flex;
  flex-direction: row;
  width: 90vw;
  justify-content: space-between;
  padding-top: 50px;
  margin-bottom: 30px;
  padding-bottom: 30px;
  top: 0;
  position: sticky;
  z-index: 100;
  background-color: var(--rootBackgroundColor);

  @media (max-width: 900px) {
    margin-top: 30px;
    margin-bottom: 30px;
  }
`;

const Right = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

export default function LoggedInHeader() {
  const { loggedInUser, isMobile } = useContext(Context);

  if (!loggedInUser) return null;

  if (isMobile)
    return (
      <>
        <NavBarWithInvertedCurve />
        <PwaInstallButton />
      </>
    );

  return (
    <TopPart>
      <BrandContainer />

      <Right>
        <PwaInstallButton />
        <MembershipMiniInfo />
        <NavBar />
      </Right>
    </TopPart>
  );
}
